import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      className="design-iconfont"
    >
      <path
        d="M7.42857143,19 L6.14285714,19 L6.14285714,17.4523693 C6.14285714,17.1182218 5.93392857,16.8368344 5.64464286,16.7664875 C2.9125,16.186126 1,13.4777723 1,10.2066439 L1,9.50317538 L2.28571429,9.50317538 L2.28571429,10.2066439 C2.28571429,12.8094773 3.76428571,14.9374695 5.88571429,15.394724 C6.78571429,15.5881778 7.42857143,16.4499267 7.42857143,17.469956 L7.42857143,19 Z M13.8571429,19 L12.5714286,19 L12.5714286,17.4523693 C12.5714286,16.4499267 13.2142857,15.5705911 14.1142857,15.3771373 C16.2357143,14.9374695 17.7142857,12.8094773 17.7142857,10.2066439 L17.7142857,9.50317538 L19,9.50317538 L19,10.2066439 C19,13.4777723 17.0875,16.186126 14.3553571,16.7664875 C14.0660714,16.8368344 13.8571429,17.1182218 13.8571429,17.4523693 L13.8571429,19 Z M10.0160714,14.506595 L9.01164487,13.5131522 C5.45752012,9.9832596 3.12029678,8.01751103 3.12029678,5.14286796 C3.12029678,2.817789 4.78146378,1 6.90621227,1 C8.10379779,1 9.26275151,1.61297536 10.0160714,2.58528111 C10.7693913,1.61297536 11.9283451,1 13.1259306,1 C15.2506791,1 16.9118461,2.817789 16.9118461,5.14286796 C16.9118461,7.99637394 14.5746227,9.9832596 11.020498,13.5131522 L10.0160714,14.506595 Z"
        fill="#00A870"
        fillRule="nonzero"
      />
    </svg>
  )
}

const GuideIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} />
    </ActionIcon>
  )
}

export default GuideIcon
